import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { addEditServiceRequest } from "../../../../commons/ServiceRequest";
import OperatingProceduresCustomerForm from "../../../../components/MainForm/OperatingProceduresCustomerForm";
import DataRecordingCommandForm from "../../../../components/MainForm/DataRecordingCommandForm";
import ItemStdCustomersService from "../../../../services/itemstdcustomer.service";
import ItemStdRecordsService from "../../../../services/itemstdrecord.service";

export default function AddServiceRequest() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const titleId =
    state?.type === "StdCus"
      ? "เพิ่มขั้นตอนการปฏิบัติงานเฉพาะลูกค้า"
      : "เพิ่มคำสั่งการบันทึกข้อมูล";
  const descriptionText =
    state?.type === "customers"
      ? "Additional Customer Specific Steps"
      : "Data Recording Command";

  return (
    <>
      <Helmet>
        <title>{titleId}</title>
        <meta name="description" content={`Add ${descriptionText} Page`} />
      </Helmet>

      <Container fluid className="p-3">
        {state?.type === "StdCus" ? (
          <OperatingProceduresCustomerForm
            searchValue={state?.searchValue}
            onSubmitCallback={(data) =>
              addEditServiceRequest({
                showAlert,
                setLoading,
                serviceRequest:
                  ItemStdCustomersService.createItemStdCustomers(data),
                navigated: (navi) => navi && navigate(0)
              })
            }
          />
        ) : (
          <DataRecordingCommandForm
            searchValue={state?.searchValue}
            onSubmitCallback={(data) =>
              addEditServiceRequest({
                showAlert,
                setLoading,
                serviceRequest:
                  ItemStdRecordsService.createItemStdRecords(data),
                navigated: (navi) => navi && navigate(0)
              })
            }
          />
        )}
      </Container>
    </>
  );
}
